<template>
    <q-tabs v-if="!$breakpoints.isGreaterThan('xs')" color="dark" class="bg-dark" style="padding: 10px">
       <!-- <q-route-tab v-ripple slot="title" to="/"><span class="text-white"><img src="../../img/identity/logo-pocket.png">2020</span></q-route-tab>-->
        <q-route-tab v-ripple slot="title" to="/"><span class="text-white uppercase">{{ $T('inicio') }}</span></q-route-tab>
        <q-route-tab v-ripple slot="title" :to="{name: 'contact'}"><span class="text-white uppercase">{{ $T('contact us') }}</span></q-route-tab>
        <q-route-tab v-ripple slot="title" :to="{name: 'tec'}"><span class=" text-white uppercase">{{ $T('terms ans conditions') }}</span></q-route-tab>
        <q-route-tab v-ripple slot="title" :to="{name: 'cancel-subscription'}"><span class="text-white uppercase">{{ $T('cancel') }}</span></q-route-tab>
    </q-tabs>
    <div v-else class="bg-dark" style="padding: 15px">
        <div class="container bg-dark">
            <div class="row items-center no-wrap justify-between bg-dark">
                <span class="text-white"><img src="../../img/identity/logo-pocket.png" alt="Intimizone" class="logo-footer">&copy; {{ date }}</span>
                <div class="col-auto row items-center">
                    <ul class="gt-xs">
                        <li>
                            <router-link to="/" class="text-white footer-text uppercase">{{ $T('inicio') }}</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'contact'}" class="text-white footer-text uppercase">{{ $T('contact us') }}</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'tec'}" class="text-white footer-text uppercase">{{ $T('terms ans conditions') }}</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'cancel-subscription'}" class="text-white footer-text uppercase">{{ $T('cancel') }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment"
    import {
        QTabs,
        QRouteTab
    } from 'quasar-framework'

    export default {
        components: {
            QTabs,
            QRouteTab
        },

        computed: {
            menus() {
                return window.config.menus
            },

            devFolder() {
                return window.config.devAssetsFolder
            }
        },
        data() {
            return {
                date: moment().format("YYYY")
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .logo-footer
        max-width 23vh
        margin-bottom -10px
        padding-right 10px
    .menu-name
        height 30px
        line-height 13px
        font-size 14px
        position relative
        font-weight 600
        display block
        width 60px
        text-align left
        text-transform capitalize
        white-space initial
    .q-layout-footer .q-tabs .q-tab
        padding 10px;
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue